import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { MediaQuery } from '@uhg-abyss/web/ui/MediaQuery';
import { usePageCollapsingHeader } from 'src/state/pageCollapsingHeader';
import { styled } from '@uhg-abyss/web/tools/styled';
import { AppSearch } from '../../../Header/LogoActionBar/AppSearch';

const StyledZIndexPaddedDiv = styled('div', {
  zIndex: 1150,
  paddingLeft: '6px',
});

export const AppSearchContainer = ({ handleAppSearch }) => {
  const breakpoint = 984;
  const [isSmallerThanBreakPoint, setIsSmallerThanBreakPoint] = useState(false);
  const { showPageCollapsingHeader } = usePageCollapsingHeader.state();

  useEffect(() => {
    function updateViewPort() {
      if (window.innerWidth < breakpoint) {
        setIsSmallerThanBreakPoint(true);
      } else {
        setIsSmallerThanBreakPoint(false);
      }
    }
    window.addEventListener('resize', updateViewPort);
    updateViewPort();
    return () => window.removeEventListener('resize', updateViewPort);
  }, []);

  if (showPageCollapsingHeader || isSmallerThanBreakPoint) {
    return null;
  }
  return (
    <MediaQuery largerThan={984}>
      <StyledZIndexPaddedDiv>
        <AppSearch onSearch={() => handleAppSearch()} />
      </StyledZIndexPaddedDiv>
    </MediaQuery>
  );
};

AppSearchContainer.propTypes = {
  handleAppSearch: PropTypes.func.isRequired,
};
